import { useFormContext } from 'react-hook-form'

import { BaseRepresentanteLegalForm } from '@/features/proposta/brasil/components/ui'
import type { CompradorVinculoStepSchemaInput } from '@/features/proposta/brasil/domain/schemas/compradores/comprador-pf.schema'
import { useClientePorCpfProposta } from '@/features/proposta/brasil/hooks/use-cliente-por-cpf-proposta'
import { useDadosRepresentanteLegalVinculo } from '@/features/proposta/brasil/hooks/use-dados-representante-legal-vinculo'
import type { TCompradoresCadastrados } from '@/features/proposta/brasil/types/proposta.type'
import { useNacionalidadeCache } from '@/features/proposta/shared/hooks/use-nacionalidade-cache'
import type { TProfissao } from '@/types/cliente'

type TDadosCompradorVinculo = {
  onBack: () => void
  onNext: () => void
  compradores: TCompradoresCadastrados
  profissoes: TProfissao[]
}

export const DadosRepresentanteLegalVinculo = ({ onNext, onBack, compradores, profissoes }: TDadosCompradorVinculo) => {
  const {
    formState: { errors },
    watch,
    control,
  } = useFormContext<CompradorVinculoStepSchemaInput>()

  const cpf = watch('dados.cpf')
  const buscouCpf = !!watch('dados.buscouCpf')
  const cpfRaw = cpf?.replaceAll(/\D/g, '')
  const cpfError = errors?.dados?.cpf
  const isEditing = watch('mode') === 'edit'

  const { nacionalidadePrincipalId, nacionalidades } = useNacionalidadeCache()

  const { refetch, isFetching } = useClientePorCpfProposta(String(cpfRaw), false)
  const { handlers } = useDadosRepresentanteLegalVinculo({
    onNext,
    compradores,
    refetch,
    nacionalidadePrincipalId,
  })

  return (
    <BaseRepresentanteLegalForm
      onBack={onBack}
      onNext={onNext}
      compradores={compradores}
      nacionalidades={nacionalidades}
      profissoes={profissoes}
      control={control}
      fields={{
        cpf: 'dados.cpf',
        nome: 'dados.nome',
        nacionalidadeId: 'dados.nacionalidadeId',
        profissaoId: 'dados.profissaoId',
      }}
      isEditing={isEditing}
      cpf={cpf}
      buscouCpf={buscouCpf}
      cpfError={cpfError}
      isFetching={isFetching}
      handlers={handlers}
    />
  )
}
